
import * as actionTypes from './actionTypes';

export const initDhcpStart = () => {
  return {
    type: actionTypes.INIT_DHCP_START
  };
};
export const resetDhcpState = () => {
  return {
    type: actionTypes.RESET_DHCP_STATE,

  };
}
export const refreshDhcp = () => {
  return window.location.reload();
};
export const setDhcp = (realDhcp) => {
  return {
    type: actionTypes.SET_DHCP,
    realDhcp: realDhcp
  };
};

export const fetchDhcpFailed = () => {
  return {
    type: actionTypes.FETCH_DHCP_FAILED
  };
};

export const initDhcp = () => {
  return {
    type: actionTypes.INIT_DHCP
  };
};

export const addPortAssignment = (payload, ip, devMac) => {
  let hostName = payload.hostName;
  return {
    type: actionTypes.ADD_PORT_ASSIGNMENT,
    devMac: devMac,
    ip: ip,
    name: payload.formData.name,
    internalPort: payload.formData.internalPort,
    externalPort: payload.formData.externalPort,
    protocol: payload.formData.protocol,
    withPortForwarding: true,
  };
};
export const deletePortAssignment = (ip, devMac, externalPort) => {
  return {
    type: actionTypes.DELETE_PORT_ASSIGNMENT,
    devMac: devMac,
    ip: ip,
    externalPort: externalPort,
    withPortForwarding: true,
  };
};
export const changePortAssignment = (payload, ip, devMac, externalPort) => {
  let hostName = payload.hostName;
  return {
    type: actionTypes.CHANGE_PORT_ASSIGNMENT,
    devMac: devMac,
    ip: ip,
    name: payload.formData.name,
    internalPort: payload.formData.internalPort,
    externalPort: externalPort,
    protocol: payload.formData.protocol,
    withPortForwarding: true,
  };
};
export const addIpReservation = (ip, devMac, hostName, addToDHCP, callback, requestedFrom='') => {
  return {
    type: actionTypes.ADD_IP_RESERVATION,
    devMac: devMac,
    ip: ip,
    hostName: hostName,
    addToDHCP,
    callback,
    requestedFrom
  };
};
export const deleteIpReservation = (deviceInfo, requestedFrom='') => {
  return {
    type: actionTypes.DELETE_IP_RESERVATION,
    deviceInfo,
    requestedFrom
  };
};
export const changeDhcpFailed = () => {
  return {
    type: actionTypes.CHANGE_DHCP_FAILED
  }
}
export const changeDhcpSuccess = () => {
  return {
    type: actionTypes.CHANGE_DHCP_SUCCESS
  }
}

export const resetDhcpErrorSuccess = () => {
  return {
    type: actionTypes.RESET_DHCP_ERROR_SUCCESS
  }
}

export const setDhcpError = () => {
  return {
    type: actionTypes.SET_DHCP_ERROR
  }
}
